var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-alert",
        {
          directives: [
            { name: "show", rawName: "v-show", value: true, expression: "true" }
          ],
          attrs: { color: "primary", value: "true", outline: "" }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.$t("botWarning")) + " "),
          _c("code", [
            _vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))
          ]),
          _vm._v(". " + _vm._s(_vm.$t("botWarning3")) + "\n  ")
        ]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alert,
              expression: "alert"
            }
          ],
          attrs: {
            color: "secondary",
            icon: "warning",
            value: "true",
            outline: ""
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.$t("botWarning2")) + " "),
          _c("code", [
            _vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.alert
        ? _c(
            "div",
            [
              _vm.loadingGet
                ? _c(
                    "div",
                    { staticClass: "text-xs-center" },
                    [
                      _c("v-progress-circular", {
                        staticClass: "primary--text",
                        attrs: { indeterminate: "", size: 100, width: 1 }
                      })
                    ],
                    1
                  )
                : _c(
                    "v-card",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      label: _vm.onOff
                                        ? "CHATBOT ON"
                                        : "CHATBOT OFF",
                                      light: "",
                                      color: "primary"
                                    },
                                    model: {
                                      value: _vm.onOff,
                                      callback: function($$v) {
                                        _vm.onOff = $$v
                                      },
                                      expression: "onOff"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _vm.onOff
                                    ? _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center"
                                              },
                                              attrs: { md6: "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                chatbot selectionné : "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.botSelected[0]
                                                        .USR_FIRST_NAME
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.botSelected[0]
                                                        .USR_LAST_NAME
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { md6: "" } },
                                            [
                                              _c("wz-select-bots", {
                                                attrs: {
                                                  label: "Choisissez le Bot",
                                                  bot: _vm.bot,
                                                  listeBots:
                                                    _vm.$store.state._User.bots,
                                                  openFromExt:
                                                    _vm.openBeforeclose,
                                                  testChatbot: false
                                                },
                                                on: {
                                                  "update:bot": function(
                                                    $event
                                                  ) {
                                                    _vm.bot = $event
                                                  },
                                                  reInitBots: _vm.reInitBots
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "v-expansion-panel",
                [
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "primary--text" }, [
                            _vm._v("settings")
                          ]),
                          _vm._v(_vm._s(_vm.$t("botOptions")))
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm.contextPriorityBot,
                                          light: "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.optionNoAgent,
                                          callback: function($$v) {
                                            _vm.optionNoAgent = $$v
                                          },
                                          expression: "optionNoAgent"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm.$t("botBoutons"),
                                          light: "",
                                          color: "primary",
                                          hint: _vm.$t("botBoutons2"),
                                          "persistent-hint": "",
                                          disabled: !_vm.onOff
                                        },
                                        model: {
                                          value: _vm.buttonsHorizontal,
                                          callback: function($$v) {
                                            _vm.buttonsHorizontal = $$v
                                          },
                                          expression: "buttonsHorizontal"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm.$t("botBloquer"),
                                          light: "",
                                          color: "primary",
                                          hint: _vm.$t("botWatson"),
                                          "persistent-hint": "",
                                          disabled: !_vm.onOff
                                        },
                                        model: {
                                          value: _vm.blocTextarea,
                                          callback: function($$v) {
                                            _vm.blocTextarea = $$v
                                          },
                                          expression: "blocTextarea"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { class: [_vm.getPermissions ? "active" : "hidden"] },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "primary--text" }, [
                            _vm._v("schedule")
                          ]),
                          _vm._v(
                            " \n           " +
                              _vm._s(_vm.$t("botRestric")) +
                              " \n          "
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.openDialog({
                                    title: _vm.$t("botVisualiser"),
                                    content: _vm.$t("botVisuDesc")
                                  })
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "infos",
                                      attrs: {
                                        color: "grey lighten-1",
                                        dark: ""
                                      }
                                    },
                                    [_vm._v("info")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("enSavoirPlus")))
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-card",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "header" },
                                          slot: "header"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("cap")(
                                                _vm.$t("displayTimes")
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md6: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  attrs: {
                                                    hint: _vm.$t(
                                                      "defineWidgetHours"
                                                    ),
                                                    "persistent-hint": ""
                                                  },
                                                  model: {
                                                    value: _vm.form.hours,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "hours",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.hours"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: _vm._f("cap")(
                                                        _vm.$t("allTheTime")
                                                      ),
                                                      color: "primary",
                                                      value: "all"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: _vm._f("cap")(
                                                        _vm.$t("customHours")
                                                      ),
                                                      color: "primary",
                                                      value: "defined"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.form.hours == "defined"
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs12: "" } },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "primary--text",
                                                      attrs: { flat: "" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.openHours()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "timesSeveralDays"
                                                          )
                                                        )
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" }
                                                        },
                                                        [_vm._v("event")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-expansion-panel",
                                                _vm._l(_vm.form.days, function(
                                                  day
                                                ) {
                                                  return _c(
                                                    "v-expansion-panel-content",
                                                    { key: day.name },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            slot: "header",
                                                            "align-center": "",
                                                            row: "",
                                                            spacer: ""
                                                          },
                                                          slot: "header"
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "hidden-md-and-up"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      day.name.substring(
                                                                        0,
                                                                        3
                                                                      )
                                                                    ) + ". : "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "hidden-sm-and-down"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      day.name
                                                                    ) + " : "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              day.am.active ||
                                                              day.pm.active
                                                                ? _c("span", [
                                                                    day.am
                                                                      .active
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "from"
                                                                                  )
                                                                                )
                                                                            ),
                                                                            _c(
                                                                              "code",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    day
                                                                                      .am
                                                                                      .start
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "to"
                                                                                  )
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                            _c(
                                                                              "code",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    day
                                                                                      .am
                                                                                      .end
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    day.am
                                                                      .active &&
                                                                    day.pm
                                                                      .active
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "and"
                                                                                  )
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    day.pm
                                                                      .active
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "from"
                                                                                )
                                                                              ) +
                                                                                " "
                                                                            ),
                                                                            _c(
                                                                              "code",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    day
                                                                                      .pm
                                                                                      .start
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "to"
                                                                                  )
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                            _c(
                                                                              "code",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    day
                                                                                      .pm
                                                                                      .end
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ])
                                                                : _c("span", [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "cap"
                                                                          )(
                                                                            _vm.$t(
                                                                              "disabledToday"
                                                                            )
                                                                          )
                                                                        )
                                                                      )
                                                                    ])
                                                                  ])
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-card",
                                                        {
                                                          staticClass:
                                                            "grey lighten-3"
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-text",
                                                            [
                                                              _c(
                                                                "v-layout",
                                                                {
                                                                  attrs: {
                                                                    row: "",
                                                                    wrap: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs12:
                                                                          "",
                                                                        sm6: "",
                                                                        md2: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-switch",
                                                                        {
                                                                          attrs: {
                                                                            label: _vm._f(
                                                                              "cap"
                                                                            )(
                                                                              _vm.$t(
                                                                                "activateMorning"
                                                                              )
                                                                            ),
                                                                            light:
                                                                              "",
                                                                            color:
                                                                              "primary"
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              day
                                                                                .am
                                                                                .active,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                day.am,
                                                                                "active",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "day.am.active"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs12:
                                                                          "",
                                                                        sm6: "",
                                                                        md2: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator",
                                                                            label:
                                                                              _vm.$t(
                                                                                "from"
                                                                              ) +
                                                                              " " +
                                                                              day.name +
                                                                              " " +
                                                                              _vm.$t(
                                                                                "morning"
                                                                              ),
                                                                            "prepend-icon":
                                                                              "access_time",
                                                                            disabled: !day
                                                                              .am
                                                                              .active,
                                                                            readonly:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.openTimePicker(
                                                                                day,
                                                                                "am",
                                                                                "start"
                                                                              )
                                                                            }
                                                                          },
                                                                          slot:
                                                                            "activator",
                                                                          model: {
                                                                            value:
                                                                              day
                                                                                .am
                                                                                .start,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                day.am,
                                                                                "start",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "day.am.start"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs12:
                                                                          "",
                                                                        sm6: "",
                                                                        md2: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator",
                                                                            label:
                                                                              _vm.$t(
                                                                                "to"
                                                                              ) +
                                                                              " " +
                                                                              day.name +
                                                                              " " +
                                                                              _vm.$t(
                                                                                "morning"
                                                                              ),
                                                                            "prepend-icon":
                                                                              "access_time",
                                                                            disabled: !day
                                                                              .am
                                                                              .active,
                                                                            readonly:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.openTimePicker(
                                                                                day,
                                                                                "am",
                                                                                "end"
                                                                              )
                                                                            }
                                                                          },
                                                                          slot:
                                                                            "activator",
                                                                          model: {
                                                                            value:
                                                                              day
                                                                                .am
                                                                                .end,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                day.am,
                                                                                "end",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "day.am.end"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-layout",
                                                                {
                                                                  attrs: {
                                                                    row: "",
                                                                    wrap: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs12:
                                                                          "",
                                                                        sm6: "",
                                                                        md2: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-switch",
                                                                        {
                                                                          attrs: {
                                                                            label: _vm._f(
                                                                              "cap"
                                                                            )(
                                                                              _vm.$t(
                                                                                "activateAfternoon"
                                                                              )
                                                                            ),
                                                                            light:
                                                                              "",
                                                                            color:
                                                                              "primary"
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              day
                                                                                .pm
                                                                                .active,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                day.pm,
                                                                                "active",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "day.pm.active"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs12:
                                                                          "",
                                                                        sm6: "",
                                                                        md2: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator",
                                                                            label:
                                                                              _vm.$t(
                                                                                "from"
                                                                              ) +
                                                                              " " +
                                                                              day.name +
                                                                              " " +
                                                                              _vm.$t(
                                                                                "afternoon"
                                                                              ),
                                                                            "prepend-icon":
                                                                              "access_time",
                                                                            disabled: !day
                                                                              .pm
                                                                              .active,
                                                                            readonly:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.openTimePicker(
                                                                                day,
                                                                                "pm",
                                                                                "start"
                                                                              )
                                                                            }
                                                                          },
                                                                          slot:
                                                                            "activator",
                                                                          model: {
                                                                            value:
                                                                              day
                                                                                .pm
                                                                                .start,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                day.pm,
                                                                                "start",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "day.pm.start"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs12:
                                                                          "",
                                                                        sm6: "",
                                                                        md2: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator",
                                                                            label:
                                                                              _vm.$t(
                                                                                "to"
                                                                              ) +
                                                                              " " +
                                                                              day.name +
                                                                              " " +
                                                                              _vm.$t(
                                                                                "afternoon"
                                                                              ),
                                                                            "prepend-icon":
                                                                              "access_time",
                                                                            disabled: !day
                                                                              .pm
                                                                              .active,
                                                                            readonly:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.openTimePicker(
                                                                                day,
                                                                                "pm",
                                                                                "end"
                                                                              )
                                                                            }
                                                                          },
                                                                          slot:
                                                                            "activator",
                                                                          model: {
                                                                            value:
                                                                              day
                                                                                .pm
                                                                                .end,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                day.pm,
                                                                                "end",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "day.pm.end"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("language")
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm._f("cap")(_vm.$t("urlDisplay"))) +
                              "\n          "
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.openDialog({
                                    title: _vm.$t("botVisualiser2"),
                                    content: _vm.$t("botVisuDesc2")
                                  })
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "infos",
                                      attrs: {
                                        color: "grey lighten-1",
                                        dark: ""
                                      }
                                    },
                                    [_vm._v("info")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("enSavoirPlus")))
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-card",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  attrs: {
                                                    hint: _vm.$t(
                                                      "chooseWhiteOrBlackChatbot"
                                                    ),
                                                    "persistent-hint": ""
                                                  },
                                                  model: {
                                                    value: _vm.form.urls,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "urls",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.urls"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: _vm._f("cap")(
                                                        _vm.$t("everywhere")
                                                      ),
                                                      color: "primary",
                                                      value: "all"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: "White List",
                                                      color: "primary",
                                                      value: "showOnOff"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: "Black List",
                                                      color: "primary",
                                                      value: "hideOnOff"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.form.urls != "all",
                                              expression: "form.urls != 'all'"
                                            }
                                          ],
                                          attrs: { wrap: "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c(
                                                        "v-fab-transition",
                                                        {
                                                          attrs: {
                                                            slot: "activator"
                                                          },
                                                          slot: "activator"
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.form
                                                                      .urls !=
                                                                    "all",
                                                                  expression:
                                                                    "form.urls != 'all'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "secondary",
                                                              attrs: {
                                                                dark: "",
                                                                absolute: "",
                                                                top: "",
                                                                right: "",
                                                                fab: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.openRule()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v("add")
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-data-table", {
                                                        attrs: {
                                                          headers:
                                                            _vm.headersRules,
                                                          items: _vm.form.rules,
                                                          "no-data-text": _vm.$t(
                                                            "noRules"
                                                          ),
                                                          "hide-actions": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "items",
                                                              fn: function(
                                                                props
                                                              ) {
                                                                return [
                                                                  props.item
                                                                    .list ===
                                                                  _vm.form.urls
                                                                    ? _c(
                                                                        "td",
                                                                        [
                                                                          _c(
                                                                            "v-edit-dialog",
                                                                            {
                                                                              attrs: {
                                                                                "return-value":
                                                                                  props
                                                                                    .item
                                                                                    .type,
                                                                                "cancel-text": _vm.$t(
                                                                                  "cancel"
                                                                                ),
                                                                                "save-text": _vm.$t(
                                                                                  "submit"
                                                                                ),
                                                                                large:
                                                                                  ""
                                                                              },
                                                                              on: {
                                                                                "update:returnValue": function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.$set(
                                                                                    props.item,
                                                                                    "type",
                                                                                    $event
                                                                                  )
                                                                                },
                                                                                "update:return-value": function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.$set(
                                                                                    props.item,
                                                                                    "type",
                                                                                    $event
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      props
                                                                                        .item
                                                                                        .type
                                                                                        .text
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-3 title",
                                                                                  attrs: {
                                                                                    slot:
                                                                                      "input"
                                                                                  },
                                                                                  slot:
                                                                                    "input"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "changeType"
                                                                                      )
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "v-select",
                                                                                {
                                                                                  attrs: {
                                                                                    slot:
                                                                                      "input",
                                                                                    items:
                                                                                      _vm.typeRules,
                                                                                    "return-object":
                                                                                      "",
                                                                                    autofocus:
                                                                                      ""
                                                                                  },
                                                                                  slot:
                                                                                    "input",
                                                                                  model: {
                                                                                    value:
                                                                                      props
                                                                                        .item
                                                                                        .type,
                                                                                    callback: function(
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        props.item,
                                                                                        "type",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                    expression:
                                                                                      "props.item.type"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  props.item
                                                                    .list ===
                                                                  _vm.form.urls
                                                                    ? _c(
                                                                        "td",
                                                                        [
                                                                          _c(
                                                                            "v-edit-dialog",
                                                                            {
                                                                              attrs: {
                                                                                "cancel-text": _vm.$t(
                                                                                  "cancel"
                                                                                ),
                                                                                "save-text": _vm.$t(
                                                                                  "submit"
                                                                                ),
                                                                                "return-value":
                                                                                  props
                                                                                    .item
                                                                                    .content,
                                                                                large:
                                                                                  "",
                                                                                lazy:
                                                                                  ""
                                                                              },
                                                                              on: {
                                                                                "update:returnValue": function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.$set(
                                                                                    props.item,
                                                                                    "content",
                                                                                    $event
                                                                                  )
                                                                                },
                                                                                "update:return-value": function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.$set(
                                                                                    props.item,
                                                                                    "content",
                                                                                    $event
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  _c(
                                                                                    "code",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          props
                                                                                            .item
                                                                                            .content
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-3 title",
                                                                                  attrs: {
                                                                                    slot:
                                                                                      "input"
                                                                                  },
                                                                                  slot:
                                                                                    "input"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "editContent"
                                                                                      )
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "v-text-field",
                                                                                {
                                                                                  attrs: {
                                                                                    slot:
                                                                                      "input",
                                                                                    label:
                                                                                      "Modification",
                                                                                    "single-line":
                                                                                      "",
                                                                                    counter:
                                                                                      "",
                                                                                    autofocus:
                                                                                      ""
                                                                                  },
                                                                                  slot:
                                                                                    "input",
                                                                                  model: {
                                                                                    value:
                                                                                      props
                                                                                        .item
                                                                                        .content,
                                                                                    callback: function(
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        props.item,
                                                                                        "content",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                    expression:
                                                                                      "props.item.content"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  props.item
                                                                    .list ===
                                                                  _vm.form.urls
                                                                    ? _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-right"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs: {
                                                                                icon:
                                                                                  "",
                                                                                flat:
                                                                                  ""
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.deleteRule(
                                                                                    props.index
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                [
                                                                                  _vm._v(
                                                                                    "delete"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          false,
                                                          2258000570
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "text-xs-center" },
                    [
                      _c("v-progress-circular", {
                        staticClass: "primary--text",
                        attrs: { indeterminate: "", size: 100, width: 1 }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-right" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        block: _vm.$vuetify.breakpoint.xsOnly,
                        loading: _vm.loadingPost
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.postOptions()
                        }
                      }
                    },
                    [
                      _vm._v(_vm._s(_vm._f("cap")(_vm.$t("save")))),
                      _c("v-icon", { attrs: { dark: "", right: "" } }, [
                        _vm._v("save")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("wz-dialog-infos", {
                attrs: {
                  titleDialog: _vm.titleDialog,
                  contentDialog: _vm.contentDialog
                },
                on: { fermeDialog: _vm.fermeDialogInfos }
              }),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", lazy: "", "max-width": "290" },
                  model: {
                    value: _vm.showTp,
                    callback: function($$v) {
                      _vm.showTp = $$v
                    },
                    expression: "showTp"
                  }
                },
                [
                  _c(
                    "v-time-picker",
                    {
                      attrs: {
                        actions: "",
                        scrollable: "",
                        format: "24hr",
                        max: _vm.allowed.hours.max,
                        min: _vm.allowed.hours.min,
                        color: "primary"
                      },
                      model: {
                        value: _vm.daySelected[_vm.amOrPm][_vm.startOrEnd],
                        callback: function($$v) {
                          _vm.$set(
                            _vm.daySelected[_vm.amOrPm],
                            _vm.startOrEnd,
                            $$v
                          )
                        },
                        expression: "daySelected[amOrPm][startOrEnd]"
                      }
                    },
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.showTp = false
                              _vm.daySelected[_vm.amOrPm][_vm.startOrEnd] =
                                _vm.tmpHours
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("cancel"))))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.showTp = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("submit"))))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { scrollable: "", persistent: "", width: "350px" },
                  model: {
                    value: _vm.showHours,
                    callback: function($$v) {
                      _vm.showHours = $$v
                    },
                    expression: "showHours"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text" },
                        [
                          _vm._v(
                            _vm._s(_vm._f("cap")(_vm.$t("applySchedules")))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticStyle: { height: "400px" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.days,
                              label: _vm.$t("applyHours"),
                              "return-object": ""
                            },
                            model: {
                              value: _vm.dayHours,
                              callback: function($$v) {
                                _vm.dayHours = $$v
                              },
                              expression: "dayHours"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headersDays,
                              items: _vm.days,
                              "item-key": "text",
                              "select-all": "primary",
                              "hide-actions": "",
                              "total-items": 7
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "headerCell",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "subheading" },
                                        [_vm._v(_vm._s(props.header.text))]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "td",
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "primary--text",
                                            attrs: { "hide-details": "" },
                                            model: {
                                              value: props.selected,
                                              callback: function($$v) {
                                                _vm.$set(props, "selected", $$v)
                                              },
                                              expression: "props.selected"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.text))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4209351822
                            ),
                            model: {
                              value: _vm.daysTmp,
                              callback: function($$v) {
                                _vm.daysTmp = $$v
                              },
                              expression: "daysTmp"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  _vm.showHours = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: !_vm.daysTmp.length,
                                color: "primary",
                                flat: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.submitHours()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("submit")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", "max-width": "290" },
                  model: {
                    value: _vm.showDialogRule,
                    callback: function($$v) {
                      _vm.showDialogRule = $$v
                    },
                    expression: "showDialogRule"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text" },
                        [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("createRule"))))]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c(
                          "form",
                          [
                            _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                items: _vm.typeRules,
                                label: _vm.$t("ruleType"),
                                "return-object": "",
                                required: "",
                                "data-vv-name": "select",
                                error: _vm.wzErrors.has("select"),
                                "error-messages": _vm.wzErrors.collect("select")
                              },
                              model: {
                                value: _vm.ruleTmp.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleTmp, "type", $$v)
                                },
                                expression: "ruleTmp.type"
                              }
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                autofocus: "",
                                label: _vm.$t("ruleContent"),
                                required: "",
                                "data-vv-name": "ruleContentInput",
                                error: _vm.wzErrors.has("ruleContentInput"),
                                "error-messages": _vm.wzErrors.collect(
                                  "ruleContentInput"
                                )
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.submitRule()
                                }
                              },
                              model: {
                                value: _vm.ruleTmp.content,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleTmp, "content", $$v)
                                },
                                expression: "ruleTmp.content"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  _vm.showDialogRule = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                disabled: _vm.wzErrors.any(),
                                flat: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.submitRule()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("submit")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14b6cbd3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14b6cbd3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ChatBot.vue
// module id = null
// module chunks = 